import * as React from "react";
const SvgFiRrHandsHeart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hands-heart_svg__a)">
      <path
        fill="#062147"
        d="M24 6v10.101a7.95 7.95 0 0 1-2.343 5.657l-1.95 1.95a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l1.95-1.95A5.96 5.96 0 0 0 22 16.101V6c0-.551-.449-1-1-1s-1 .449-1 1l-.013 8.067a2.98 2.98 0 0 1-.688 1.856l-2.578 2.684a.998.998 0 0 1-1.414.028 1 1 0 0 1-.028-1.414l2.533-2.634a.9.9 0 0 0 .188-.585v-.046a.996.996 0 0 0-1.66-.701l-3.163 2.911a7 7 0 0 1 .824 3.276v3.559a1 1 0 0 1-2 0v-3.559a5.01 5.01 0 0 0-1.615-3.68l-2.734-2.516a.995.995 0 0 0-1.397.086 1 1 0 0 0-.021 1.305l2.57 2.671a1 1 0 1 1-1.442 1.386l-2.616-2.721a3.1 3.1 0 0 1-.723-1.854c-.005-.04-.024-8.118-.024-8.118 0-.551-.449-1-1-1s-1 .449-1 1v10.101c0 1.603.624 3.109 1.757 4.243l1.95 1.95a.999.999 0 1 1-1.414 1.414l-1.95-1.95a7.95 7.95 0 0 1-2.343-5.657V6c0-1.654 1.346-3 3-3s3 1.346 3 3v5.186a2.99 2.99 0 0 1 2.996.579l2.744 2.525c.087.08.164.168.247.252l3.008-2.768a3 3 0 0 1 3.005-.587V6.001c0-1.654 1.346-3 3-3s3 1.346 3 3zM7 3.2C7 1.435 8.346 0 10 0c.782 0 1.477.27 2 .727A3 3 0 0 1 14 0c1.654 0 3 1.436 3 3.2 0 2.004-2.042 4.064-3.754 5.438-.361.29-.803.435-1.246.435s-.885-.145-1.247-.436C9.041 7.263 7 5.203 7 3.199zm2 0c0 .904 1.152 2.391 3.006 3.879C13.848 5.591 15 4.104 15 3.2c0-.662-.449-1.2-1-1.2-.461 0-1 .262-1 1a1 1 0 0 1-2 0c0-.738-.539-1-1-1-.551 0-1 .539-1 1.2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hands-heart_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandsHeart;
